import {
    AccordionContainerDPC,
    AccordionDPC,
    PageContainerDPC,
    LinkUtiliMinisitiDPC,
    FacebookPanelDPC,
    TwitterPanelDPC,
    PhotoVideoContainerMinisitiDPC,
    CarouselMinisitiDPC,
    AgendaDPC,
    SvgIconDPC,
    PrintButtonDPC, CardHorizontalDPC, CardDPC
} from '@dpc-fe/shared';
import {graphql} from 'gatsby';
import React from 'react';
import {getSlug, getAccordionAndTabLinks} from "../functions/functions";
import DpcSidebar from "@dpc-fe/shared/components/dpc-sidebar";
import {buildMenu, findParent, getAbstract} from "@dpc-fe/shared/js/shared-functions";
import moment from "moment";
import {prop} from "../functions/functions";
import 'moment/locale/it';

export default ({data, pageContext}) => {
    const language = '/' + pageContext.lang;
    const fullmenu = buildMenu(pageContext.menu, pageContext.lang, process.env.ENV, null, data.node.drupal_internal__nid);
    const fullMenuMinisito = buildMenu(pageContext.menuMinisito, pageContext.lang, process.env.ENV, null, data.node.drupal_internal__nid);
    const submenu = findParent(fullMenuMinisito, data.node.drupal_internal__nid, "idContenuto", "children");
    const primoPianoContenuto = data.node.relationships.field_primo_piano_contenuto;
    const primoPianoImage = primoPianoContenuto && primoPianoContenuto.relationships.field_immagine_anteprima ? primoPianoContenuto.relationships.field_immagine_anteprima : null;
    const primoPianoStreaming = data.node.relationships.field_primo_piano_streaming;
    const accordion = data.node.relationships.field_accordion;
    const tipoSocial = data.node.relationships.field_box_social ? data.node.relationships.field_box_social.field_tipo_social : null;
    const faq = data.node.relationships.field_link_bottone_singolo;
    const boxCriticita = data.node.relationships.field_box_bollettino_criticita;
    const boxVigilanza = data.node.relationships.field_box_bollettino_vigilanza;
    const box1 = [boxCriticita, boxVigilanza];
    const box2 = data.node.relationships.field_box_mappa;
    const rullo1 = data.node.relationships.field_box_rullo_1 ? data.node.relationships.field_box_rullo_1.relationships.field_contenuto : [];
    const rullo2 = data.node.relationships.field_box_rullo_2 ? data.node.relationships.field_box_rullo_2.relationships.field_contenuto : [];
    const linkUtiliArray = data.node.relationships.field_link_utili_1.concat(data.node.relationships.field_link_utili_2, data.node.relationships.field_link_utili_3);
    const linkUtili = linkUtiliArray.map(item => {
        if (item.field_link_esterno) {
            return {
                slug: item.field_link.uri,
                titleLinkEsterno: "Vai al sito " + item.field_link.uri,
                title: item.field_titolo_link ? item.field_titolo_link : item.field_link.title
            }
        } else if (!item.field_link_esterno && item.relationships.field_link_interno) {
            return {
                slug: getSlug('/' + pageContext.lang + (item.relationships.field_link_interno.fields ? item.relationships.field_link_interno.fields.slug : ''), process.env.MINISITO_RISCHI, item.relationships?.field_link_interno?.relationships?.field_sottodominio?.name),
                title: item.field_titolo_link ? item.field_titolo_link : item.relationships?.field_link_interno?.title
            }
        }

    });

    const galleriaFoto = data.node.relationships.field_foto_video && data.node.relationships.field_foto_video.map(item => {
        return {
            src: item.field_categoria_primaria.toLowerCase() === 'video' ? item.field_video?.uri : item.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL,
            alt: item.field_alt ? item.field_alt: item?.relationships?.field_immagine_dettaglio?.field_alt,
            link: getSlug(language + item.fields.slug, process.env.MINISITO_RISCHI, item.relationships?.field_sottodominio?.name),
            linkTitle: item.field_titolo_esteso,
            categoria: item.field_categoria_primaria
        }
    })

    const getPreview = (bollettino) => {
      const dateFormat = "YYYYMMDD_hhmm";
      if(moment().isSame(moment(bollettino.field_data_bollettino, dateFormat), "day")){
        return bollettino.field_url_preview
      }else{
        return bollettino.field_url_preview_tomorrow
      }
    }

    const getDescrizione = (box) => {
      const dateFormat = "YYYYMMDD_hhmm";
      if(moment().isSame(moment(box.field_data_bollettino, dateFormat), "day")){
        return box.field_descrizione_today && box.field_descrizione_today.processed?.length > 250 ? box.field_descrizione_today.processed?.slice(0, 250) + '...' : box.field_descrizione_today ? box.field_descrizione_today.processed : ''
      }else{
        return box.field_descrizione_tomorrow && box.field_descrizione_tomorrow.processed?.length > 250 ? box.field_descrizione_tomorrow.processed?.slice(0, 250) + '...' : box.field_descrizione_tomorrow ? box.field_descrizione_tomorrow.processed : ''
      }
    }

    moment.locale('it');

    return (
        <PageContainerDPC isRischi={true} 
            menuItems={pageContext.menu}
            slugTraduzione={data.node.relationships.field_riferimento_traduzione ? data.node.relationships.field_riferimento_traduzione.fields.slug : ''}
            pageId={data.node.drupal_internal__nid}
            title={data.node.title}
            env={process.env.ENV}
            lang={pageContext.lang}
            domain={process.env.MINISITO_RISCHI_LABEL}
            subdomainMenuItems={pageContext.menuMinisito}
            basePathNavbar={process.env.PORTALE_URL}
            minisiti={prop}
            immagineShare={data.node.relationships?.field_immagine_dettaglio ? process.env.MINISITO_RISCHI_URL + data.node.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL: process.env.MINISITO_RISCHI_URL + pageContext.socialImg?.relationships?.image?.localFile?.publicURL}
            abstractShare={data.node.body?.processed ? data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
            slug={process.env.MINISITO_RISCHI_URL + '/' + pageContext.lang + data.node.fields.slug}
            menuFooterItems={pageContext.menuFooter}
        >
            <div className="container">
                <div className="px-custom">
                    <div className="row">
                        <div className="col-12 col-xl-8">
                            <article>
                                {(primoPianoContenuto && !data.node.field_streaming_homepage) && <>
                                    <h1>{primoPianoContenuto.field_titolo_esteso}</h1>
                                    <p><img
                                        src={primoPianoImage?.relationships.image.localFile.childImageSharp.fluid.src}
                                        alt={primoPianoImage.field_alt} className="img-fluid w-100"/></p>
                                    <div
                                        dangerouslySetInnerHTML={{__html: (primoPianoContenuto.field_abstract ? primoPianoContenuto.field_abstract.value.slice(0, 300) + '...' : '')}}/>
                                    <p>
                                        <a className="read-more"
                                           href={getSlug(primoPianoContenuto.fields ? language + primoPianoContenuto.fields.slug : '', process.env.MINISITO_RISCHI, primoPianoContenuto.relationships?.field_sottodominio?.name)}>
                                            <span className="text">Leggi di più</span>
                                            <SvgIconDPC name={'arrow-right'}/>
                                        </a>
                                    </p>
                                </>}
                                {(primoPianoStreaming && data.node.field_streaming_homepage) && <CardHorizontalDPC
                                    title={primoPianoStreaming.field_titolo}
                                    body={primoPianoStreaming.field_testo?.value}
                                    streaming={primoPianoStreaming}
                                />}


                                {Array.isArray(box1) && box1.length > 0 &&
                                <div className="row">
                                    {box1.map(box =>
                                        box ? 
                                            <div className="col-12 col-md-6">
                                                <article className="card-wrapper card-space">
                                                    <div className="card card-img card-img-2by3">
                                                        <div className="img-responsive-wrapper">
                                                            <div className="img-responsive">
                                                                <figure className="img-wrapper">
                                                                    <figcaption className="sr-only">{getPreview(box)?.title}</figcaption>
                                                                    <a href={getSlug(box.fields ? language + box.fields.slug : '', process.env.MINISITO_RISCHI, box.relationships?.field_sottodominio?.name)}>
                                                                        <img
                                                                            alt={getPreview(box) ? getPreview(box).title : null}
                                                                            src={getPreview(box) ? getPreview(box).uri : null}/>
                                                                    </a>
                                                                </figure>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <h3 className="card-title">
                                                                <a href={getSlug(box.fields ? language + box.fields.slug : '', process.env.MINISITO_RISCHI, box.relationships?.field_sottodominio?.name)}>
                                                                    {box.title}
                                                                </a>
                                                            </h3>
                                                            <div
                                                                dangerouslySetInnerHTML={{__html: (getDescrizione(box))}}/>
                                                        </div>
                                                    </div>
                                                </article>
                                            </div>
                                            : null
                                    )}
                                </div>
                                }


                                {box2 &&
                                <div className="row">
                                  <div className="col-12 col-md-6">
                                    <CardDPC
                                        title={box2.title}
                                        slug={getSlug(box2.fields ? language + box2.fields.slug : '', process.env.MINISITO_RISCHI, box2.relationships?.field_sottodominio?.name)}
                                        image={box2.relationships?.field_immagine_dettaglio}
                                    />
                                  </div>                                   
                                </div>
                                }

                                {data.node.field_agenda &&
                                <AgendaDPC allerta={true} eventi={data.eventi} locale={"it"}
                                           portale={process.env.MINISITO_RISCHI} minisiti={prop}/>
                                }

                                {(rullo1 || rullo2) &&

                                <div className="row">
                                    {(Array.isArray(rullo1) && rullo1.length > 0) &&
                                    <div
                                        className={`col-12  ${(rullo1.length > 0 && rullo2.length > 0) ? 'col-sm-6' : ''}`}>
                                        <section className="container article-card-simple">
                                            <h2>{data.node.relationships.field_box_rullo_1.field_titolo}</h2>
                                            {rullo1.map(item => (
                                                <article className="card-wrapper">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="category-top">
                                                                <a className="category">{item.field_categoria_primaria.replace(/_/g, ' ')}</a>
                                                                <span
                                                                    className="data">{moment(item.field_data).format('D MMMM Y')}</span>
                                                                <h2 className="card-title">
                                                                    <a href={getSlug(item.fields ? '/' + pageContext.lang + item.fields.slug : '', process.env.MINISITO_RISCHI, item.relationships?.field_sottodominio?.name)}>
                                                                        {item.field_titolo_esteso}
                                                                    </a>
                                                                </h2>
                                                            </div>
                                                            <div className="card-text"
                                                                 dangerouslySetInnerHTML={{__html: (item.field_abstract ? item.field_abstract.processed : '')}}/>
                                                        </div>
                                                    </div>
                                                </article>
                                            ))
                                            }
                                            <div className="card-wrapper">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <a className="read-more position-static"
                                                           href={'/' + pageContext.lang + (data.node.relationships.field_box_rullo_1.relationships.field_link_vedi_tutti ? data.node.relationships.field_box_rullo_1.relationships.field_link_vedi_tutti.fields.slug : null)}>
                                                            <span className="text">Vedi tutto</span>
                                                            <SvgIconDPC name="arrow-right"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    }
                                    {(Array.isArray(rullo2) && rullo2.length > 0) &&
                                    <div
                                        className={`col-12  ${(rullo1.length > 0 && rullo2.length > 0) ? 'col-sm-6' : ''}`}>
                                        <section className="article-card-simple">
                                            <h2>{data.node.relationships.field_box_rullo_2.field_titolo}</h2>
                                            {rullo2.map(item => (
                                                <article className="card-wrapper">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="category-top">
                                                                <a className="category">{item.field_categoria_primaria.replace(/_/g, ' ')}</a>
                                                                <span
                                                                    className="data">{moment(item.field_data).format('D MMMM Y')}</span>
                                                                <h2 className="card-title">
                                                                    <a href={getSlug(item.fields ? '/' + pageContext.lang + item.fields.slug : '', process.env.MINISITO_RISCHI, item.relationships?.field_sottodominio?.name)}>
                                                                        {item.field_titolo_esteso}
                                                                    </a>
                                                                </h2>
                                                            </div>
                                                            <div className="card-text"
                                                                 dangerouslySetInnerHTML={{__html: (item.field_abstract ? item.field_abstract.processed : '')}}/>
                                                        </div>
                                                    </div>
                                                </article>
                                            ))}
                                            <div className="card-wrapper">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <a className="read-more position-static"
                                                           href={'/' + pageContext.lang + (data.node.relationships.field_box_rullo_2.relationships.field_link_vedi_tutti ? data.node.relationships.field_box_rullo_2.relationships.field_link_vedi_tutti.fields.slug : null)}>
                                                            <span className="text">Vedi tutto</span>
                                                            <SvgIconDPC name="arrow-right"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    }

                                </div>

                                }

                                {(Array.isArray(galleriaFoto) && galleriaFoto.length > 0) &&
                                <PhotoVideoContainerMinisitiDPC
                                    title={'Foto e video'}
                                >
                                    <CarouselMinisitiDPC
                                        items={galleriaFoto}
                                        lang={`/` + pageContext.lang}
                                        itemsPerPage={2}
                                    />
                                </PhotoVideoContainerMinisitiDPC>}

                                <section className="my-5">

                                    {Array.isArray(accordion) && accordion.length > 0 &&
                                    <>
                                        <h2>{data.node.field_titolo_sezione_accordion}</h2>
                                        <AccordionContainerDPC id={"1"}>
                                            {
                                                accordion.map(node => {
                                                    return (
                                                        <AccordionDPC
                                                            title={node.field_titolo ? node.field_titolo : ''}
                                                            body={node.field_testo ? node.field_testo.processed : ''}
                                                            id={node.drupal_internal__id}
                                                            accordionId={"1"}
                                                            img={node.relationships.field_immagine}
                                                            tabella={node.field_tabella ? node.field_tabella.processed : null}
                                                            video={node.relationships.field_video}
                                                            allegati={node.relationships.field_allegati}
                                                            links={node.relationships ? getAccordionAndTabLinks(node.relationships.field_link_interni, pageContext.lang, process.env.MINISITO_RISCHI) : null}
                                                        />
                                                    )
                                                })
                                            }
                                        </AccordionContainerDPC>
                                    </>
                                    }
                                    {
                                        faq && <div className="btn-block-uppercase-wrapper">
                                            <a href={getSlug(language + faq.fields.slug, process.env.MINISITO_RISCHI, faq.relationships?.field_sottodominio?.name)}
                                               className="btn btn-tayeb-charcoal"
                                               role="button">{faq.field_titolo_esteso}</a>
                                        </div>
                                    }
                                </section>

                                {Array.isArray(linkUtili) && linkUtili.length > 0 &&
                                <LinkUtiliMinisitiDPC titoloSezione={'Link utili'} linkUtili={linkUtili}/>
                                }

                                <PrintButtonDPC/>

                            </article>
                        </div>
                        <div className="col-12 col-xl-4">

                            <DpcSidebar menuItems={[submenu]}/>

                            {tipoSocial &&
                            <aside aria-label="pannello social">
                                <h2>Social</h2>
                                <div className="row">
                                    {
                                        tipoSocial === "Facebook" && (
                                            <div className="col-12 col-sm-6 col-xl-12">
                                                <div className="rounded shadow my-4">
                                                    <FacebookPanelDPC/>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        tipoSocial === "Twitter" && (
                                            <div className="col-12 col-sm-6 col-xl-12">
                                                <div className="rounded shadow my-4">
                                                    <TwitterPanelDPC/>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </aside>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </PageContainerDPC>
    );
};

export const query = graphql`
  query($slug: String!) {
    node: nodeSezioneAllertaMeteoIdro (fields: { slug: { eq: $slug } }) {
      title
      field_streaming_homepage
      field_agenda
      field_titolo_esteso
      drupal_internal__nid
      field_id_contenuto_originale
      field_titolo_sezione_accordion
      body {
        processed
      }
      fields{
        slug
      }
      relationships {
        field_immagine_dettaglio {
          field_alt
          field_didascalia
          field_titolo_esteso
          relationships {
            image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                  fluid(maxWidth: 1100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
          }
          }
        }
        field_riferimento_traduzione {
          fields {
            slug
          }
        }
        field_accordion {
          field_titolo
          field_tabella {
            processed
          }
          field_testo {
            processed
            value
          }
          relationships {
            field_immagine {
              field_alt
              field_didascalia
              relationships {
                image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                      fluid(maxWidth: 1100) {
                        ...GatsbyImageSharpFluid_noBase64
                      }
                    }
                  }
                }
              }
            }
            field_video {
              field_video {
                title
                uri
              }
              field_didascalia
              title
              field_titolo_esteso
            }
            field_link_interni{
              ...pubblicazioneFragment
              ...notiziaFragment
              ...approfondimentoFragment
              ...normativaFragment
              ...pageFragment
              ...bandoDiGaraFragment
              ...comunicatoStampaFragment
              ...corsoFragment
              ...mappaFragment
              ...timelineFragment
              ...sezioneConAnticipazioniFragment
              ...sezioneSenzaAnticipazioniFragment
              ...elencoApprofondimentiFragment
              ...elencoGlossariFragment
              ...elencoAttualitaFragment
              ...elencoPodcastFragment
              ...elencoPubblicazioniFragment
              ...elencoNormativaFragment
              ...elencoBandiEContrattiFragment
              ...elencoFotoVideoFragment
              ...homepageVolontariatoFragment
              ...homepageRelazioniFragment
              ...homepageRischiFragment
              ...homepageNazionaleFragment
              ...homepageMappeFragment
              ...homepageGiovaniFragment
              ...homepageFormazioneFragment
              ...homepageEventiFragment
              ...homepageEmergenzeFragment
              ...homepageDocsFragment
              ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
              ...homepagePortaleFragment
              ...bollettinoCriticitaFragment
              ...bollettinoVigilanzaFragment
              ...sezioneAllertaMeteoIdroFragment
              ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
            }
            field_allegati {
              title
              field_titolo_esteso
              relationships {
                field_allegato {
                  filesize
                  localFile {
                    publicURL
                    extension
                  }
                  filename
                }
              }
            }
          }

        }
        field_box_bollettino_vigilanza{
          ...bollettinoVigilanzaFragment
        }
        field_box_bollettino_criticita{
          ...bollettinoCriticitaFragment
        }
        field_box_mappa{
          fields{
            slug
          }
          title
          body {
            processed
          }
          relationships {
            field_sottodominio {
              name
            }
            field_immagine_dettaglio {
              field_alt
              field_didascalia
              relationships{
                image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                      fluid {
                        ...GatsbyImageSharpFluid_noBase64
                      }
                    }
                  }
                }
              }
            }
          }
        }
        field_box_rullo_1 {
          field_titolo
          field_tipologia
          relationships {
            field_contenuto {
              ...notiziaFragment
              ...normativaFragment
              ...bandoDiGaraFragment
              ...comunicatoStampaFragment
            }
            field_link_vedi_tutti {
              ...elencoAttualitaFragment
              ...elencoBandiEContrattiFragment
              ...elencoNormativaFragment
            }
          }
        }
        field_box_rullo_2 {
          field_titolo
          field_tipologia
          relationships {
            field_contenuto {
              ...notiziaFragment
              ...normativaFragment
              ...bandoDiGaraFragment
              ...comunicatoStampaFragment
            }
            field_link_vedi_tutti {
              ...elencoAttualitaFragment
              ...elencoBandiEContrattiFragment
              ...elencoNormativaFragment
            }
          }
        }
        field_box_social {
          field_titolo
          field_tipo_social
        }
        field_foto_video {
          ...immagineFragment
          ...videoFragment
          ...galleriaFotoFragment
          ...galleriaFlickrFragment
        }
        field_link_bottone_singolo {
          ...pubblicazioneFragment
          ...notiziaFragment
          ...approfondimentoFragment
          ...normativaFragment
          ...pageFragment
          ...bandoDiGaraFragment
          ...comunicatoStampaFragment
          ...corsoFragment
          ...mappaFragment
          ...timelineFragment
          ...sezioneConAnticipazioniFragment
          ...sezioneSenzaAnticipazioniFragment
          ...elencoApprofondimentiFragment
          ...elencoGlossariFragment
          ...elencoAttualitaFragment
          ...elencoPodcastFragment
          ...elencoPubblicazioniFragment
          ...elencoNormativaFragment
          ...elencoBandiEContrattiFragment
          ...elencoFotoVideoFragment
          ...homepageVolontariatoFragment
          ...homepageRelazioniFragment
          ...homepageRischiFragment
          ...homepageNazionaleFragment
          ...homepageMappeFragment
          ...homepageGiovaniFragment
          ...homepageFormazioneFragment
          ...homepageEventiFragment
          ...homepageEmergenzeFragment
          ...homepageDocsFragment
          ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
          ...homepagePortaleFragment
          ...bollettinoCriticitaFragment
          ...bollettinoVigilanzaFragment
          ...sezioneAllertaMeteoIdroFragment
          ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
        }
        field_link_utili_1 {
          field_link_esterno
          field_titolo_link
          field_link {
            title
            uri
          }
          relationships {
            field_link_interno {
              ...pubblicazioneFragment
              ...notiziaFragment
              ...approfondimentoFragment
              ...normativaFragment
              ...pageFragment
              ...bandoDiGaraFragment
              ...comunicatoStampaFragment
              ...corsoFragment
              ...mappaFragment
              ...timelineFragment
              ...sezioneConAnticipazioniFragment
              ...sezioneSenzaAnticipazioniFragment
              ...elencoApprofondimentiFragment
              ...elencoGlossariFragment
              ...elencoAttualitaFragment
              ...elencoPodcastFragment
              ...elencoPubblicazioniFragment
              ...elencoNormativaFragment
              ...elencoBandiEContrattiFragment
              ...elencoFotoVideoFragment
              ...homepageVolontariatoFragment
              ...homepageRelazioniFragment
              ...homepageRischiFragment
              ...homepageNazionaleFragment
              ...homepageMappeFragment
              ...homepageGiovaniFragment
              ...homepageFormazioneFragment
              ...homepageEventiFragment
              ...homepageEmergenzeFragment
              ...homepageDocsFragment
              ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
              ...homepagePortaleFragment
              ...bollettinoCriticitaFragment
              ...bollettinoVigilanzaFragment
              ...sezioneAllertaMeteoIdroFragment
              ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
            }
          }
        }
        field_link_utili_2 {
          field_link_esterno
          field_titolo_link
          field_link {
            title
            uri
          }
          relationships {
            field_link_interno {
              ...pubblicazioneFragment
              ...notiziaFragment
              ...approfondimentoFragment
              ...normativaFragment
              ...pageFragment
              ...bandoDiGaraFragment
              ...comunicatoStampaFragment
              ...corsoFragment
              ...mappaFragment
              ...timelineFragment
              ...sezioneConAnticipazioniFragment
              ...sezioneSenzaAnticipazioniFragment
              ...elencoApprofondimentiFragment
              ...elencoGlossariFragment
              ...elencoAttualitaFragment
              ...elencoPodcastFragment
              ...elencoPubblicazioniFragment
              ...elencoNormativaFragment
              ...elencoBandiEContrattiFragment
              ...elencoFotoVideoFragment
              ...homepageVolontariatoFragment
              ...homepageRelazioniFragment
              ...homepageRischiFragment
              ...homepageNazionaleFragment
              ...homepageMappeFragment
              ...homepageGiovaniFragment
              ...homepageFormazioneFragment
              ...homepageEventiFragment
              ...homepageEmergenzeFragment
              ...homepageDocsFragment
              ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
              ...homepagePortaleFragment
              ...bollettinoCriticitaFragment
              ...bollettinoVigilanzaFragment
              ...sezioneAllertaMeteoIdroFragment
              ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
            }
          }
        }
        field_link_utili_3 {
          field_link_esterno
          field_titolo_link
          field_link {
            title
            uri
          }
          relationships {
            field_link_interno {
              ...pubblicazioneFragment
              ...notiziaFragment
              ...approfondimentoFragment
              ...normativaFragment
              ...pageFragment
              ...bandoDiGaraFragment
              ...comunicatoStampaFragment
              ...corsoFragment
              ...mappaFragment
              ...timelineFragment
              ...sezioneConAnticipazioniFragment
              ...sezioneSenzaAnticipazioniFragment
              ...elencoApprofondimentiFragment
              ...elencoGlossariFragment
              ...elencoAttualitaFragment
              ...elencoPodcastFragment
              ...elencoPubblicazioniFragment
              ...elencoNormativaFragment
              ...elencoBandiEContrattiFragment
              ...elencoFotoVideoFragment
              ...homepageVolontariatoFragment
              ...homepageRelazioniFragment
              ...homepageRischiFragment
              ...homepageNazionaleFragment
              ...homepageMappeFragment
              ...homepageGiovaniFragment
              ...homepageFormazioneFragment
              ...homepageEventiFragment
              ...homepageEmergenzeFragment
              ...homepageDocsFragment
              ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
              ...homepagePortaleFragment
              ...bollettinoCriticitaFragment
              ...bollettinoVigilanzaFragment
              ...sezioneAllertaMeteoIdroFragment
              ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
            }
          }
        }
        field_primo_piano_contenuto {
          ...pubblicazioneFragment
          ...notiziaFragment
          ...approfondimentoFragment
          ...normativaFragment
          ...pageFragment
          ...bandoDiGaraFragment
          ...comunicatoStampaFragment
          ...corsoFragment
          ...mappaFragment
          ...timelineFragment
          ...sezioneConAnticipazioniFragment
          ...sezioneSenzaAnticipazioniFragment
          ...elencoApprofondimentiFragment
          ...elencoGlossariFragment
          ...elencoAttualitaFragment
          ...elencoPodcastFragment
          ...elencoPubblicazioniFragment
          ...elencoNormativaFragment
          ...elencoBandiEContrattiFragment
          ...elencoFotoVideoFragment
          ...homepageVolontariatoFragment
          ...homepageRelazioniFragment
          ...homepageRischiFragment
          ...homepageNazionaleFragment
          ...homepageMappeFragment
          ...homepageGiovaniFragment
          ...homepageFormazioneFragment
          ...homepageEventiFragment
          ...homepageEmergenzeFragment
          ...homepageDocsFragment
          ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
          ...homepagePortaleFragment
          ...bollettinoCriticitaFragment
          ...bollettinoVigilanzaFragment
          ...sezioneAllertaMeteoIdroFragment
          ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
        }
        field_primo_piano_streaming {
            field_testo {
              value
            }
            field_link {
              uri
              title
            }
            field_titolo
        }
      }
    },
    eventi: allNodeEventi(filter: {relationships: {field_sottodominio: {name: {eq: "Rischi"}}}}) {
        edges {
            node {
                body {
                    processed
                }
                field_link {
                  title
                  uri
                }
                relationships {
                     field_link_interno {
                      ...pubblicazioneFragment
                      ...notiziaFragment
                      ...approfondimentoFragment
                      ...normativaFragment
                      ...pageFragment
                      ...bandoDiGaraFragment
                      ...comunicatoStampaFragment
                      ...corsoFragment
                      ...mappaFragment
                      ...timelineFragment
                      ...sezioneConAnticipazioniFragment
                      ...sezioneSenzaAnticipazioniFragment
                      ...elencoApprofondimentiFragment
                      ...elencoGlossariFragment
                      ...elencoAttualitaFragment
                      ...elencoPodcastFragment
                      ...elencoPubblicazioniFragment
                      ...elencoNormativaFragment
                      ...elencoBandiEContrattiFragment
                      ...elencoFotoVideoFragment
                      ...homepageVolontariatoFragment
                      ...homepageRelazioniFragment
                      ...homepageRischiFragment
                      ...homepageNazionaleFragment
                      ...homepageMappeFragment
                      ...homepageGiovaniFragment
                      ...homepageFormazioneFragment
                      ...homepageEventiFragment
                      ...homepageEmergenzeFragment
                      ...homepageDocsFragment
                      ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
                      ...homepagePortaleFragment
                      ...bollettinoCriticitaFragment
                      ...bollettinoVigilanzaFragment
                      ...sezioneAllertaMeteoIdroFragment
                      ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
                    }
                    field_allegati {
                        title
                        field_titolo_esteso
                        relationships {
                          field_sottodominio {
                            name
                          }
                          field_allegato {
                            filesize
                            filename
                            localFile {
                              publicURL
                              extension
                            }
                          }
                        }
                    }
                }
                field_link_esterno
                field_data_evento
                title
                field_titolo_esteso
                field_luogo
            }
        }
    }
  }
`;
